import serviceRequest from "utils/request";

const baseUrl = "/param";

export const getConfig = (params) => {
	return serviceRequest({
		url: `${baseUrl}/frontend/config`,
		method: "get",
		params,
	});
};
